import { CircularProgress } from "@mui/material";
import { REQUEST_STATUS } from "hooks/useRequest/useRequest.constants";
import { FC, useEffect } from "react";
import { SaveButtonStyled } from "./SaveButton.style";
import { IButton } from "./SaveButton.types";
import { toast } from "react-hot-toast";

const SaveButton: FC<IButton> = ({
  type = "submit",
  disabled = false,
  status = REQUEST_STATUS.initial,
  fullWidth = false,
  form = "",
  label = "Save",
  endIcon,
  onClick = () => {},
  ...props
}) => {
  useEffect(() => {
    if (status === REQUEST_STATUS.success) {
      toast.success("Saved!");
    }
  }, [status]);

  return (
    <SaveButtonStyled
      disabled={disabled}
      type={type}
      fullWidth={fullWidth}
      onClick={onClick}
      variant={"contained"}
      endIcon={endIcon}
      {...props}
    >
      {status === REQUEST_STATUS.loading && (
        <div className="buttonLoader">
          <div className="backgroundOpacity" />
          <CircularProgress />
        </div>
      )}
      {label}
    </SaveButtonStyled>
  );
};

export default SaveButton;
